if ( $( 'body' ).hasClass( 'template-collection' ) && $( 'body' ).hasClass( 'template-suffix-bundle' ) ) {
  $( '.product-block-bundle' ).each( function () {
    var namespace = theme.namespaceFromSection( this );
    var productSingleObject = JSON.parse( $( '[data-product-json]', this ).html() );

    var options = {
        $container: $(this),
        enableHistoryState: false,
        singleOptionSelector: '[data-single-option-selector]',
        originalSelectorId: '[data-product-select]',
        secondaryIdSelectors: '[data-product-secondary-select]',
        product: productSingleObject };
    
    var variants = new slate.Variants( options );
    
    theme.initVariantSelectors( $( '[data-single-option-selector]', this ), productSingleObject );

    $(this).on( 'variantChange' + namespace, theme.variants.updateAddToCartState.bind( this ) );
    $(this).on( 'variantPriceChange' + namespace, theme.variants.updateProductPrices.bind( this ) );

    if ( variants.product.variants.length > 1 ) {
        // emit an event to broadcast the variant update
        $(window).trigger( 'cc-variant-updated', {
          variant: variants.currentVariant,
          product: productSingleObject } );

      }

    theme.initAjaxAddToCartForm( $( 'form.ajax-product-form', this ) );
  });

  $readMoreJS.init({
     target: '.product-block-bundle__description',           // Selector of the element the plugin applies to (any CSS selector, eg: '#', '.'). Default: ''
     numOfWords: 150,               // Number of words to initially display (any number). Default: 50
     toggle: true,                 // If true, user can toggle between 'read more' and 'read less'. Default: true
     moreLink: read_more_text,    // The text of 'Read more' link. Default: 'read more ...'
     lessLink: read_less_text         // The text of 'Read less' link. Default: 'read less'
  });

  var add_bundle_to_cart_ajax = false;
  $( '#add-bundle-to-cart-button' ).on( 'click', function ( evt ) {
    
    $( this ).addClass( 'loading' ).prop( 'disabled', 'disabled' );
    if ( !add_bundle_to_cart_ajax ) {
      add_bundle_to_cart_ajax = jQuery.ajax( {
        method: 'POST',
        url: window.Shopify.routes.root + 'cart/add.js',
        data: { 'items': bundle_add_to_cart_products },
        success: function ( data ) {
          var cartProductsHtml = '',
              itemData = JSON.parse( data );
  
          itemData.items.forEach( ( cartItem ) => {
            var productQty = '';
            if (itemData.quantity > 1) {
              productQty = ' <span class="cart-summary__quantity">' + itemData.quantity + '</span>';
            }
            cartProductsHtml += '<div class="cart-summary__product">';
            cartProductsHtml += '<div class="cart-summary__product-image"><img class="global-border-radius" src="' + cartItem.featured_image.url + '" role="presentation" alt=""></div>';
            cartProductsHtml += '<div class="cart-summary__product__description">';
            cartProductsHtml += '<div class="cart-summary__product-title">'+ cartItem.product_title + productQty + '</div>';
            cartProductsHtml += '<div class="cart-summary__variant">';
            cartProductsHtml += '<span class="cart-summary__variant-label">' + cartItem.options_with_values[0].name + ':</span> ';
            cartProductsHtml += '<span class="cart-summary__variant-value">' + cartItem.options_with_values[0].value + '</span>';
            cartProductsHtml += '</div>';
            cartProductsHtml += '<div class="cart-summary__price">' + theme.Shopify.formatMoney( cartItem.final_line_price, theme.moneyFormatWithCodeForCartPreference ) + '</div>';
            cartProductsHtml += '</div>';
            cartProductsHtml += '</div>';
          })
          
          // additional fetch - for full cart data
          $.getJSON(theme.routes.cart_url + '.js', function (cartData) {
            
            var $template = $([
              '<div class="added-notice global-border-radius added-notice--pre-reveal">',
              '<div class="added-notice__header">',
              '<span class="added-notice__title">', theme.strings.addedToCartPopupTitle, '</span>',
              '<a class="added-notice__close feather-icon" href="#" aria-label="', theme.strings.close, '">', theme.icons.close, '</a>',
              '</div>',
              '<div class="cart-summary global-border-radius">',
              cartProductsHtml,
              '<div class="cart-summary__footer">',
              '<div class="cart-summary__total-quantity-row">',
              '<span>', theme.strings.addedToCartPopupItems, '</span>',
              '<span>', cartData.item_count, '</span>',
              '</div>',
              '<div class="cart-summary__total-price-row large-text">',
              '<span>', theme.strings.addedToCartPopupSubtotal, '</span>',
              '<span class="theme-money">', theme.Shopify.formatMoney(cartData.total_price, theme.moneyFormatWithCodeForCartPreference), '</span>',
              '</div>',
              '<a href="', theme.routes.cart_url, '" class="btn btn--primary btn--small btn--fullwidth cart-summary__button">', theme.strings.addedToCartPopupGoToCart, '</a>',
              '</div>',
              '</div>'].
            join(''));
            $template.appendTo('body');
  
            // transition in
            setTimeout(function () {
              $template.removeClass('added-notice--pre-reveal');
            }, 10);
  
            // transition out
            theme.addedToCartNoticeHideTimeoutId = setTimeout(function () {
              $template.find('.added-notice__close').trigger('click');
            }, 5000);
          });
  
          $.ajax({
              type: 'GET',
              url: theme.routes.cart_url + '?sections=header,main-cart',
              success: function success(data) {
                var toReplace = {
                  'header': ['.page-header .header-cart', '.docked-navigation-container .header-cart'],
                  'main-cart': ['[data-section-type="cart"] .cart-items', '[data-section-type="cart"] .subtotal-row'] };
  
                Object.keys(toReplace).forEach((section) => {
                  var $newDom = $(data[section]);
                  $newDom.find('.fade-in').removeClass('fade-in');
  
                  for (var i = 0; i < toReplace[section].length; i++) {
                    $(toReplace[section][i]).html(
                    $newDom.find(toReplace[section][i]).html());
  
                  }
                });
              },
              error: function error(data) {
                if (data.statusText != 'abort') {
                  console.log('Error refreshing page');
                  console.log(data);
                }
              },
              complete: function complete() {
                //_.cartRefreshXhr = null;
              } });
        },
        error: function ( data ) {
          var error = JSON.parse( data.responseText );
          //Not added, show message
          var error_message = '';
          if (typeof error != 'undefined' && error.responseJSON && error.responseJSON.description ) {
            error_message = error.responseJSON.description;
          } else if (typeof error != 'undefined' && error.description ) {
            error_message = error.description;
          }
  
          if ( error_message != '' ) {
            theme.showQuickPopup( error_message, $( '#add-bundle-to-cart-button' ) );
          }
        },
        complete: function () {
          $( '#add-bundle-to-cart-button' ).removeClass( 'loading' ).prop( 'disabled', false );
          add_bundle_to_cart_ajax = false;
        }
      });
    }
  });
}

// Fix bug with language switcher on registry pages not redirecting properly from French to English
let params = new URL(document.location).searchParams;
let lang = params.get('lang');
if ( lang == 'fr' && ! window.location.pathname.startsWith( '/fr/' ) ) {
  window.location.href = window.location.pathname;
}

jQuery( '.directions-button' ).on( 'click', function ( evt ) {
  gtag('event', 'get directions button', {
    'action': 'click',
    'label': 'get directions button click'
  });
});

jQuery( '#shopify-section-template--16697726861539__d82c706e-0047-4672-bf47-ca97c2a9fe29 a' ).on( 'click', function ( evt ) {
  gtag('event', 'contact page address', {
    'action': 'click',
    'label': 'contact page address click'
  });
});